import MessageDialog from '@/components/dialogs/MessageDialog';
import CrownWithStars from '@/assets/crown_stars';
import { useTranslation } from 'react-i18next';

export default function CustomLinkModal({ ...props }) {
  const { t } = useTranslation();

  return (
    <MessageDialog
      forceModal
      title={t('checkout.customLinks.exclusiveAccess')}
      text=<div
        dangerouslySetInnerHTML={{
          __html: t('checkout.customLinks.modalText', {
            name: props.name,
            qty: props.maxTickets,
          }),
        }}
      />
      acceptLabel={t('checkout.customLinks.buttonText')}
      icon={
        <>
          <CrownWithStars />
        </>
      }
      {...props}
    />
  );
}
